import RichText from '~/src/common/components/CMS/RichText';
import { GetRecipeByIdOrSlug200 } from '~/src/queries/api-ecom/generated/api-ecom.schemas';

import * as S from './layout';

interface Props {
  description: GetRecipeByIdOrSlug200['description'];
  descripionTitle: GetRecipeByIdOrSlug200['descriptionTitle'];
}

export const RECIPE_DESCRIPTION_ID = 'recipe-description';

const RecipeDescription = ({ description, descripionTitle }: Props) => (
  <S.Root id={RECIPE_DESCRIPTION_ID}>
    <S.Content>
      <h2>{descripionTitle}</h2>
      <RichText html={description} />
    </S.Content>
  </S.Root>
);
export default RecipeDescription;
